import { stripUnit } from 'polished';

export const DEFAULT_UNIT = 'px';

/**
 * Get unit size
 * @param size
 * @param unit
 * @returns {string}
 */
export function unit(size: number | string, unit: string = DEFAULT_UNIT): string | number {
    size = stripUnit(size);

    if (!size) {
        return 0;
    }

    return `${size}${unit}`;
}

/**
 * Get strict unit size just for number values
 * @param size
 * @param unit$
 * @returns {string}
 */
export function unitStrict(size: number | string, unit$: string = DEFAULT_UNIT): string | number {
    if (typeof size === 'number') {
        return unit(size, unit$);
    }
    return size;
}

export { stripUnit };
